import LegalLayout from "../components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      overline="LEGAL · PRIVACY"
      path="/privacy"
      description="How Martingale Playbook collects, uses, and protects your personal information."
    >
      <p>
        <em>Last updated: February 2026</em>
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">What we collect</h2>
      <ul className="list-disc list-inside space-y-2">
        <li><strong>Account data</strong>: email, name (optional), hashed password.</li>
        <li><strong>Bet tracker entries</strong>: only what you manually log (sport, pick, stake, result).</li>
        <li><strong>Usage</strong>: basic request logs for debugging and abuse prevention.</li>
        <li><strong>Billing</strong>: handled by Stripe. We receive a Stripe customer ID and subscription status — never your full card number.</li>
      </ul>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">How we use it</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>To authenticate you and personalize AI picks to your bankroll.</li>
        <li>To send the morning digest and weekly recap when you opt in.</li>
        <li>To process your subscription.</li>
        <li>To email you transactional messages (password resets, verification).</li>
      </ul>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">What we don't do</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>Sell your data. Ever.</li>
        <li>Share your tracker with other users.</li>
        <li>Hand your information to advertisers.</li>
      </ul>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">Subprocessors</h2>
      <ul className="list-disc list-inside space-y-2">
        <li><strong>Stripe</strong> — billing and subscription management.</li>
        <li><strong>Google Gmail SMTP</strong> — transactional and digest email delivery.</li>
        <li><strong>Anthropic</strong> — Claude Sonnet analyzes public game data to produce picks; your personal data is not sent.</li>
        <li><strong>The Odds API / ESPN</strong> — public sports data.</li>
      </ul>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">Your rights</h2>
      <p>
        You can view or delete all of your tracker data from the Tracker page. You can
        delete your account by emailing us from the contact page — we remove personal
        data within 30 days (retaining only what's legally required for billing records).
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">Cookies</h2>
      <p>
        We use one HTTP-only session cookie (<code className="mono text-[#00D4FF]">mp_session</code>)
        to keep you logged in. No advertising or cross-site tracking cookies.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">Contact</h2>
      <p>
        Privacy questions? Email via the <a href="/contact" className="neon-text underline">contact page</a>.
      </p>
    </LegalLayout>
  );
}
